import './style.scss';
import { ReactComponent as AttentionIcon } from '@assets/images/attention.svg';
import { ReactComponent as WarningIcon } from '@assets/images/warningIcon.svg';

export type InfoMessageType = 'info' | 'error';

interface BannerMessageProps {
  type?: InfoMessageType;
  title?: string;
  message: string;
  hidden: boolean;
}

export const BannerMessage = ({
  type = 'info',
  message,
  title,
  hidden,
}: BannerMessageProps) => {
  return (
    <div className={`banner-message banner-message--${type}`} hidden={hidden}>
      <i className="banner-message__icon">
        {type === 'info' ? <AttentionIcon /> : <WarningIcon />}
      </i>
      <div className="banner-message__content">
        {title && <p className="banner-message__title">{title}</p>}
        <p className="banner-message__message">{message}</p>
      </div>
    </div>
  );
};
